export default __webpack_public_path__ + "static/media/testbanner2.4b098930.png";